module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('chart', {
    attrs: {
      "includeTotals": true,
      "path": "/api/people/GetChartSales"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bg-lighter py-2 px-3"
  }, [_c('div', {
    staticClass: "radius-normal bg-lightest border-light p-4 my-3"
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('ul', {
    staticClass: "micro-tabs"
  }, _vm._l((_vm.tabs), function(tab, key) {
    return _c('li', {
      class: {
        active: (key === _vm.activeTab)
      },
      on: {
        "click": function($event) {
          return _vm.toggleTab($event, key)
        }
      }
    }, [_vm._v(_vm._s(tab))])
  }), 0), _vm._v(" "), _c('a', {
    staticClass: "alt ml-auto",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.viewReport.apply(null, arguments)
      }
    }
  }, [_vm._v("View report")])]), _vm._v(" "), _c('div', {
    staticClass: "micro-tabs-content"
  }, [(_vm.activeTab === 0) ? _c('div', [_vm._m(0)]) : _c('div', [_c('ul', {
    staticClass: "top-sales"
  }, _vm._l((_vm.sales), function(sale) {
    return _c('li', [_c('img', {
      staticClass: "radius-normal",
      attrs: {
        "src": "/static/images/product1.jpg"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "bold darker"
    }, [_vm._v(_vm._s(sale.name))]), _vm._v(" "), _c('div', {
      staticClass: "bold dark fs-small"
    }, [_vm._v(_vm._s(sale.tickets) + " tickets sold")])])
  }), 0)])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table fs-normal"
  }, [_c('thead', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Commissions")]), _vm._v(" "), _c('th', [_vm._v("Unit")]), _vm._v(" "), _c('th', [_vm._v("Amount")])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Reservations")]), _vm._v(" "), _c('td', [_vm._v("0,00€")]), _vm._v(" "), _c('td', [_vm._v("0")]), _vm._v(" "), _c('td', [_vm._v("0,00€")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a948597"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/people/agents/AgentOverview.vue
// module id = 1271
// module chunks = 0